module.exports = __webpack_public_path__ + "6fb27c3079114ba9d7b2495f3b4508d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cut_graphic.png
// module id = 341
// module chunks = 0